import * as Sentry from "@sentry/react";

export default function logContext(context: any) {
  Sentry.setContext("Context", context);
}
